const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const isRateLimit = (error) => {
  const text = `${error?.message || ''} ${error?.status || ''}`.toLowerCase();
  return text.includes('rate limit') || text.includes('429') || text.includes('too many');
};

/** Runs an API call, backing off and retrying while we're rate limited. */
export async function withRateLimitRetry(fn, attempts = 5) {
  for (let attempt = 1; ; attempt++) {
    try {
      return await fn();
    } catch (error) {
      if (!isRateLimit(error) || attempt >= attempts) throw error;
      await sleep(1500 * 2 ** (attempt - 1));
    }
  }
}

/** Runs an async op over a list in small paced chunks, retrying rate limits. */
export async function runInPacedChunks(items, fn, { chunkSize = 3, delayMs = 900 } = {}) {
  for (let i = 0; i < items.length; i += chunkSize) {
    const chunk = items.slice(i, i + chunkSize);
    await Promise.all(chunk.map((item) => withRateLimitRetry(() => fn(item))));
    if (i + chunkSize < items.length) await sleep(delayMs);
  }
}